import * as React from 'react';
import {
  ChangeAction,
  OnAwaited_KeywordsChange_Action,
  OnBatchUpdateAction,
  OnChangeKeywordsAction,
  OnChangeResourceTypeAction,
  OnChangeStatusAction,
  OnClickLoadingMordAction,
  OnMountAction,
  OnUnmountAction,
  ResourceListPageModelState,
} from '@/models/resourceListPage';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { ConnectState } from '@/models/connect';
import FNoDataTip from '@/components/FNoDataTip';
import FLoadingTip from '@/components/FLoadingTip';
import { FI18n, FUtil } from '@freelog/tools-lib';
import * as AHooks from 'ahooks';
import styles from './index.less';
import FResourceTypeFilter3 from '@/components/FResourceTypeFilter3';
import FComponentsLib from '@freelog/components-lib';
import { Checkbox, Affix, Space } from 'antd';
import FResourceCard from '@/components/FResourceCard';
import FListFooter from '@/components/FListFooter';
import FResourceCard_AbleCheck from '@/components/FResourceCard_AbleCheck';
// import fPolicyBuilder from '@/components/fPolicyBuilder';
import fPromiseModalConfirm from '@/components/fPromiseModalConfirm';
import fSignResourceToNode from '@/components/fSignResourceToNode';
import { history } from '@@/core/history';
import fBatchHandleResource_ResultModal from '@/components/fBatchHandleResource_ResultModal';
import FHotspotTooltip, { fSetHotspotTooltipVisible } from '@/components/FHotspotTooltip';
import fCollectionSelector from '@/components/fCollectionSelector';
import FAddResourcesHandleAuth from '@/components/FAddResourcesHandleAuth';
import FIcons from '@/components/FIcons';
import fMessage from '@/components/fMessage';
import FDropdown2 from '@/components/FDropdown2';
import FInput_Search from '@/components/FInput_Search';
import fPolicyBuilder3 from '@/components/fPolicyBuilder3';

interface ResourceProps {
  dispatch: Dispatch;
  resourceListPage: ResourceListPageModelState;
}

function Resources({ dispatch, resourceListPage }: ResourceProps) {
  const [$resourceStatusOptions, set$resourceStatusOptions, get$resourceStatusOptions] =
    FUtil.Hook.useGetState([
      { text: FI18n.i18nNext.tAuto('filter_resource_status_all'), value: '#' },
      {
        text:
          // 上架
          FI18n.i18nNext.tAuto('filter_resource_status_availableforauth'),
        value: 1,
      },
      {
        text:
          // 下架
          FI18n.i18nNext.tAuto('filter_resource_status_pendingauth'),
        value: 4,
      },
      {
        text:
          // 待发行
          FI18n.i18nNext.tAuto('filter_resource_status_prepareforrelease'),
        value: 0,
      },
      {
        text:
          // 冻结
          FI18n.i18nNext.tAuto('filter_resource_status_removedbyfreelog'),
        value: 2,
      },
    ]);

  const [$affixed, set$affixed, get$affixed] = FUtil.Hook.useGetState<boolean>(false);

  const [$collectionID, set$collectionID, get$collectionID] = FUtil.Hook.useGetState<string>('');

  AHooks.useMount(() => {
    dispatch<OnMountAction>({
      type: 'resourceListPage/onMount',
    });
  });

  AHooks.useUnmount(() => {
    dispatch<OnUnmountAction>({
      type: 'resourceListPage/onUnmount',
    });
  });

  AHooks.useDebounceEffect(
    () => {
      dispatch<OnAwaited_KeywordsChange_Action>({
        type: 'resourceListPage/onAwaited_KeywordsChange',
      });
    },
    [resourceListPage.inputText],
    {
      wait: 300,
    },
  );

  AHooks.useDebounceEffect(
    () => {
      const allIDs: string[] = resourceListPage.resource_List
        .filter((ol) => {
          return ol.status !== 2;
        })
        .map((ol) => {
          return ol.id;
        });
      dispatch<ChangeAction>({
        type: 'resourceListPage/change',
        payload: {
          checkedResourceIDs: resourceListPage.checkedResourceIDs.filter((id) => {
            return allIDs.includes(id);
          }),
        },
      });
    },
    [resourceListPage.resource_List],
    {
      wait: 30,
    },
  );

  if (resourceListPage.resource_ListState === 'loading') {
    return <FLoadingTip height={'calc(100vh - 140px)'} />;
  }

  if (resourceListPage.resource_ListState === 'noData') {
    return (
      <FNoDataTip
        height={'calc(100vh - 140px)'}
        // tipText={'未创建任何资源'}
        tipText={FI18n.i18nNext.tJSXElement('my_resource_empty')}
        // btnText={'创建资源'}
        btnText={FI18n.i18nNext.tAuto('my_resource_empty_btn')}
        onClick={() => {
          self.open(FUtil.LinkTo.resourceCreatorEntry());
        }}
      />
    );
  }

  return (
    <>
      <div style={{ height: 40 }} />
      <div className={styles.filter}>
        <div className={styles.filterLeft}>
          <div>
            <span>{FI18n.i18nNext.tAuto('resource_type')}：</span>
            <FResourceTypeFilter3
              subjectTypeArr={['resource']}
              value={resourceListPage.resourceTypeCodes}
              onChange={(value) => {
                dispatch<OnChangeResourceTypeAction>({
                  type: 'resourceListPage/onChangeResourceType',
                  payload: {
                    value: value,
                  },
                });
              }}
            />
          </div>
          <div style={{ width: 60 }} />
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span>{FI18n.i18nNext.tAuto('resource_state')}：</span>
            <FDropdown2
              autoArrow={true}
              // getPopupContainer={() => ref_Root.current as HTMLElement}
              menu={{
                // selectedKeys: [nodeManagerPage.exhibit_SelectedStatus],
                items: $resourceStatusOptions.map((rs) => {
                  return {
                    key: rs.value,
                    label: rs.text,
                  };
                }),
                onClick: (value) => {
                  dispatch<OnChangeStatusAction>({
                    type: 'resourceListPage/onChangeStatus',
                    payload: {
                      value: value.key === '#' ? value.key : (Number(value.key) as 0),
                    },
                  });
                },
              }}
            >
              <span>
                {$resourceStatusOptions.find((rs) => {
                  return rs.value === resourceListPage.resourceStatus;
                })?.text || ''}
              </span>
            </FDropdown2>
          </div>
          {!resourceListPage.isBatchManagement && (
            <>
              <div style={{ width: 60 }} />
              <FHotspotTooltip
                id={'myResourceList.batchManagementButton'}
                style={{ left: 20, bottom: -38 }}
                text={
                  <div
                    style={{
                      // width: 'fit-content'
                      minWidth: 210,
                    }}
                  >
                    {FI18n.i18nNext.tAuto('hotpots_myresource_bulkaction')}
                  </div>
                }
                onOpenChange={(o) => {
                  if (o) {
                    fSetHotspotTooltipVisible('myResourceList.batchManagementButton', {
                      value: false,
                      effectiveImmediately: false,
                      onlyNullish: false,
                    });
                  }
                }}
              >
                <FComponentsLib.FTextBtn
                  style={{ fontSize: 14 }}
                  onClick={() => {
                    fSetHotspotTooltipVisible('myResourceList.batchManagementButton', {
                      value: false,
                      effectiveImmediately: true,
                      onlyNullish: false,
                    });
                    dispatch<ChangeAction>({
                      type: 'resourceListPage/change',
                      payload: {
                        isBatchManagement: true,
                      },
                    });
                  }}
                >
                  <FIcons.FConfiguration style={{ fontSize: 14 }} />
                  &nbsp;{FI18n.i18nNext.tAuto('myresources_btn_bulkaction')}
                </FComponentsLib.FTextBtn>
              </FHotspotTooltip>
            </>
          )}
        </div>
        <Space size={20}>
          <FInput_Search
            value={resourceListPage.inputText}
            style={{ width: 400 }}
            placeholder={FI18n.i18nNext.t('resourcemngt_search_hint')}
            onChange={(e) => {
              dispatch<OnChangeKeywordsAction>({
                type: 'resourceListPage/onChangeKeywords',
                payload: {
                  value: e.target.value,
                },
              });
            }}
          />
        </Space>
      </div>

      {resourceListPage.resource_ListState === 'noSearchResult' && (
        <FNoDataTip
          height={'calc(100vh - 220px)'}
          tipText={
            // 没有符合条件的资源
            FI18n.i18nNext.tAuto('msg_search_no_resault_found', {
              SearchKeyWords: resourceListPage.inputText_search,
            })
          }
          btnText={
            // 创建资源
            FI18n.i18nNext.tAuto('my_resource_empty_btn')
          }
          onClick={() => {
            self.open(FUtil.LinkTo.resourceCreatorEntry());
          }}
        />
      )}

      {resourceListPage.resource_ListState === 'loaded' && (
        <>
          <div style={{ height: 15 }} />
          {resourceListPage.isBatchManagement && (
            <>
              <Affix
                offsetTop={0}
                target={() => {
                  return self.document.querySelector(
                    '#layout-content .simplebar-content-wrapper',
                  ) as HTMLElement;
                }}
                onChange={(affixed) => {
                  set$affixed(affixed ?? false);
                }}
              >
                <div
                  className={styles.batchHandle}
                  style={
                    $affixed
                      ? {
                        backgroundColor: 'white',
                        margin: '0 -1000px',
                        height: 70,
                      }
                      : {}
                  }
                >
                  <div className={styles.batchHandleCenter}>
                    <div className={styles.batchHandleLeft}>
                      <Checkbox
                        checked={
                          resourceListPage.checkedResourceIDs.length !== 0 &&
                          resourceListPage.checkedResourceIDs.length ===
                          resourceListPage.resource_List.filter((r) => {
                            return r.status !== 2;
                          }).length
                        }
                        indeterminate={
                          resourceListPage.checkedResourceIDs.length !== 0 &&
                          resourceListPage.checkedResourceIDs.length !==
                          resourceListPage.resource_List.filter((r) => {
                            return r.status !== 2;
                          }).length
                        }
                        onChange={(e) => {
                          if (e.target.checked) {
                            dispatch<ChangeAction>({
                              type: 'resourceListPage/change',
                              payload: {
                                checkedResourceIDs: resourceListPage.resource_List
                                  .filter((o) => {
                                    return o.status !== 2;
                                  })
                                  .map((o) => {
                                    return o.id;
                                  }),
                              },
                            });
                          } else {
                            dispatch<ChangeAction>({
                              type: 'resourceListPage/change',
                              payload: {
                                checkedResourceIDs: [],
                              },
                            });
                          }
                        }}
                      />
                      <div style={{ width: 10 }} />
                      <FComponentsLib.FContentText
                        text={FI18n.i18nNext.tAuto('myresources_bulkaction_checkbox_selectall')}
                        type={'normal'}
                      />
                      <div style={{ width: 30 }} />
                      <FComponentsLib.FContentText
                        text={
                          // 已选择${resourceListPage.checkedResourceIDs.length}个资源
                          FI18n.i18nNext.tAuto('myresources_bulkaction_label_selectedqty', {
                            Qty: resourceListPage.checkedResourceIDs.length,
                          })
                        }
                        type={'additional2'}
                        style={{ fontSize: 14 }}
                      />
                    </div>

                    <div className={styles.batchHandleRight}>
                      <FComponentsLib.FTextBtn
                        disabled={resourceListPage.checkedResourceIDs.length === 0}
                        type={'primary'}
                        onClick={async () => {
                          if (resourceListPage.checkedResourceIDs.length > 100) {
                            fMessage(FI18n.i18nNext.tAuto('additem_alert_qtylimit'), 'warning');
                          }
                          const collectionID = await fCollectionSelector();
                          if (!collectionID) {
                            return;
                          }
                          set$collectionID(collectionID);
                        }}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 5,
                        }}
                      >
                        <FIcons.FResource style={{ fontSize: 14, color: 'inherit' }} />
                        <span>
                          {
                            // 添加至合集
                            FI18n.i18nNext.tAuto('addtomycollection_btn')
                          }
                        </span>
                      </FComponentsLib.FTextBtn>

                      <FComponentsLib.FTextBtn
                        disabled={resourceListPage.checkedResourceIDs.length === 0}
                        type={'primary'}
                        onClick={async () => {
                          const result = await fSignResourceToNode({
                            resourceIDs: resourceListPage.checkedResourceIDs,
                          });
                          if (result) {
                            if (
                              Object.values(result.resultData).some((v) => {
                                return v.status === 2;
                              })
                            ) {
                              await fBatchHandleResource_ResultModal({
                                type: 'signNode',
                                dataSource: result.resultData,
                              });
                            }

                            if (result.allIsTheme) {
                              history.push(
                                FUtil.LinkTo.nodeManagement({
                                  nodeID: result.nodeID,
                                  showPage: 'theme',
                                }),
                              );
                            } else {
                              history.push(
                                FUtil.LinkTo.nodeManagement({
                                  nodeID: result.nodeID,
                                }),
                              );
                            }
                          }
                        }}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 5,
                        }}
                      >
                        <FIcons.FNodes style={{ fontSize: 14, color: 'inherit' }} />
                        <span>
                          {
                            // 添加至节点
                            FI18n.i18nNext.tAuto('myresources_bulkaction_btn_addtomynode')
                          }
                        </span>
                      </FComponentsLib.FTextBtn>

                      <FComponentsLib.FTextBtn
                        disabled={resourceListPage.checkedResourceIDs.length === 0}
                        type={'primary'}
                        onClick={() => {
                          dispatch<OnBatchUpdateAction>({
                            type: 'resourceListPage/onBatchUpdate',
                            payload: {
                              status: 1,
                            },
                          });
                        }}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 5,
                        }}
                      >
                        <FIcons.FUpcast style={{ fontSize: 14 }} />
                        <span>
                          {/* 上架 */}
                          {FI18n.i18nNext.tAuto('myresources_bulkaction_btn_availabletoauth')}
                        </span>
                      </FComponentsLib.FTextBtn>

                      <FComponentsLib.FTextBtn
                        disabled={resourceListPage.checkedResourceIDs.length === 0}
                        type={'primary'}
                        onClick={async () => {
                          const bool: boolean = await fPromiseModalConfirm({
                            title: FI18n.i18nNext.t('remove_resource_from_auth_confirmation_title'),
                            description: FI18n.i18nNext.t('confirm_msg_remove_resource_from_auth'),
                            okText: FI18n.i18nNext.t('remove_resource_from_auth_btn_remve'),
                            promptKey_localStorage:
                              FI18n.i18nNext.t('remove_resource_from_auth_confirmation_title') ||
                              '',
                          });

                          if (bool) {
                            dispatch<OnBatchUpdateAction>({
                              type: 'resourceListPage/onBatchUpdate',
                              payload: {
                                status: 4,
                              },
                            });
                          }
                        }}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 5,
                        }}
                      >
                        <FIcons.FUpcast style={{ fontSize: 14, transform: 'rotate(180deg)' }} />
                        <span>
                          {/* 下架 */}
                          {FI18n.i18nNext.tAuto('myresources_bulkaction_removefromauth')}
                        </span>
                      </FComponentsLib.FTextBtn>

                      <FComponentsLib.FTextBtn
                        type={'primary'}
                        disabled={resourceListPage.checkedResourceIDs.length === 0}
                        onClick={async () => {

                          const resourceTypeCodes: string[] = resourceListPage.resource_List.filter((r) => {
                            return resourceListPage.checkedResourceIDs.includes(r.id);
                          }).map((r) => {
                            return r.resourceTypeCode;
                          });

                          const result = await fPolicyBuilder3({
                            // targetType: 'resource',
                            resourceTypeCode: Array.from(new Set(resourceTypeCodes)),
                          });
                          if (!result) {
                            return;
                          }

                          dispatch<OnBatchUpdateAction>({
                            type: 'resourceListPage/onBatchUpdate',
                            payload: {
                              addPolicies: [
                                {
                                  policyName: result.title,
                                  policyText: window.encodeURIComponent(result.text),
                                  status: 1,
                                },
                              ],
                            },
                          });
                        }}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 5,
                        }}
                      >
                        <FIcons.FPolicy style={{ fontSize: 14 }} />
                        <span>
                          {/* 添加授权策略 */}
                          {FI18n.i18nNext.tAuto('myresources_bulkaction_btn_addauthplan')}
                        </span>
                      </FComponentsLib.FTextBtn>

                      <FComponentsLib.FTextBtn
                        type={'danger'}
                        onClick={() => {
                          dispatch<ChangeAction>({
                            type: 'resourceListPage/change',
                            payload: {
                              isBatchManagement: false,
                              checkedResourceIDs: [],
                            },
                          });
                        }}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 5,
                        }}
                      >
                        <FIcons.FExit style={{ fontSize: 14 }} />
                        <span>
                          {/* 退出批量管理 */}
                          {FI18n.i18nNext.tAuto('myresources_bulkaction_btn_quit')}
                        </span>
                      </FComponentsLib.FTextBtn>
                    </div>
                  </div>
                </div>
              </Affix>
              <div style={{ height: 15 }} />
            </>
          )}

          <div className={styles.Content}>
            {!resourceListPage.isBatchManagement && (
              <div
                className={styles.createCard}
                onClick={() => {
                  self.open(FUtil.LinkTo.resourceCreatorEntry());
                }}
              >
                <div className={styles.createButton}>
                  <i className={['freelog', 'fl-icon-tianjia'].join(' ')} />
                </div>
                {/* <span className={styles.createText}>创建资源</span> */}
                <span className={styles.createText}>
                  {FI18n.i18nNext.tAuto('my_resource_empty_btn')}
                </span>
              </div>
            )}

            {resourceListPage.resource_List.map((i, j) => {
              if (resourceListPage.isBatchManagement) {
                return (
                  <FResourceCard_AbleCheck
                    showUserInfo={false}
                    checked={resourceListPage.checkedResourceIDs.includes(i.id)}
                    disabled={i.status === 2}
                    key={i.id}
                    resource={{
                      title: i.title || i.name.split('/')[1],
                      cover: i.cover,
                      resourceType: i.type.join('/'),
                      latestVersion: i.version,
                      policies: i.policy,
                      status: i.status,
                      updateDate: i.updateDate,
                      username: i.username,
                      useAvatar: i.useAvatar,
                      isChoice: i.isChoice,
                      authProblem: i.authProblem,
                    }}
                    onChange={(value) => {
                      if (value) {
                        dispatch<ChangeAction>({
                          type: 'resourceListPage/change',
                          payload: {
                            checkedResourceIDs: [...resourceListPage.checkedResourceIDs, i.id],
                          },
                        });
                      } else {
                        dispatch<ChangeAction>({
                          type: 'resourceListPage/change',
                          payload: {
                            checkedResourceIDs: resourceListPage.checkedResourceIDs.filter((id) => {
                              return id !== i.id;
                            }),
                          },
                        });
                      }
                    }}
                  />
                );
              }

              return (
                <FResourceCard
                  showUserInfo={false}
                  key={i.id}
                  resource={i}
                  type={'resource'}
                  className={styles.FResourceCard}
                  // onBoomJuice={() => onBoomJuice && onBoomJuice(i.id, i, j)}
                  onClickDetails={() => {
                    self.open(
                      FUtil.LinkTo.resourceDetails({
                        resourceID: i.id,
                      }),
                    );
                  }}
                  onClickEditing={() => {
                    self.open(
                      FUtil.LinkTo.resourceVersionInfo({
                        resourceID: i.id,
                        // version: i.version || undefined,
                      }),
                    );
                  }}
                  onClickRevision={() => {
                    self.open(
                      FUtil.LinkTo.resourceVersionCreator({
                        resourceID: i.id,
                      }),
                    );
                  }}
                // onClickMore={() => onClickMore && onClickMore(i.id, i, j)}
                />
              );
            })}
            <div className={styles.bottomPadding} />
            <div className={styles.bottomPadding} />
            <div className={styles.bottomPadding} />
            <div className={styles.bottomPadding} />
          </div>
          <div style={{ height: 100 }} />

          <FListFooter
            state={resourceListPage.resource_ListMore}
            onClickLoadMore={async () => {
              // await fetchResourceList(false);
              dispatch<OnClickLoadingMordAction>({
                type: 'resourceListPage/onClickLoadingMord',
              });
            }}
          />
        </>
      )}
      <div style={{ height: 100 }} />
      <FAddResourcesHandleAuth
        resourceIDs={resourceListPage.checkedResourceIDs}
        collectionID={$collectionID}
        onCancel={() => {
          set$collectionID('');
        }}
        onOk={() => {
          set$collectionID('');
        }}
        onBack={async () => {
          set$collectionID('');
          const collectionID = await fCollectionSelector();
          if (!collectionID) {
            return;
          }
          set$collectionID(collectionID);
        }}
        onError={() => {
          set$collectionID('');
        }}
      />
    </>
  );
}

export default connect(({ resourceListPage }: ConnectState) => ({
  resourceListPage: resourceListPage,
}))(Resources);
